import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ToolTip.less';

export const TOOLTIP_ICON_STYLE = {
    SOLID: '',
    LINE: 'icon-style-line'
};

export class ToolTip extends Component {
    static propTypes = {
        text: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        iconStyle: PropTypes.oneOf(Object.values(TOOLTIP_ICON_STYLE))
    };

    static defaultProps = {
        iconStyle: TOOLTIP_ICON_STYLE.SOLID
    };

    constructor() {
        super();
        this.state = {
            showToolTip: false
        };
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.closeTip);
    }

    componentDidMount() {
        //This is JS Event listener. The onClick attached to the <a> tag is react event.
        document.addEventListener('click', this.closeTip);
    }

    closeTip = () => {
        if (this.state.showToolTip) {
            this.setState({
                showToolTip: false
            });
        }
    };

    toggleTip = event => {
        event.preventDefault();
        //When we use a mix of JS event and react event, we have to do this.
        //This stops react event propagation
        event.stopPropagation();
        event.nativeEvent && event.nativeEvent.stopImmediatePropagation();

        this.setState({
            showToolTip: !this.state.showToolTip
        });
    };

    render() {
        const { text, id, iconStyle } = this.props;
        let toolTip;
        let toolTipContent;

        if (this.state.showToolTip) {
            toolTipContent = [
                <span key="content1" className="accessAid" />,
                <span key="content2" className="tip-bubble tip-arrow-wrapper">
                    <span className="tip-arrow" />
                </span>
            ];

            toolTip = (
                <div id={`${id}Text`} className="tip-bubble tip-hint-wrapper">
                    <div className="tip-hint" role="tooltip">
                        <span className="tip-text">{text}</span>
                    </div>
                </div>
            );
        }

        const showToolTipClass = () => this.state.showToolTip ? 'is-active' : '';

        return (
            <div className="ToolTip">
                <a
                    id={id}
                    href="#!"
                    className={`tip-icon popup ${iconStyle} ${showToolTipClass()}`}
                    tabIndex="0"
                    role="button"
                    aria-label={id}
                    onClick={this.toggleTip}
                >
                    {toolTipContent}
                </a>
                {toolTip}
            </div>
        );
    }
}

export default ToolTip;
